import {
    bexHttpClient
} from '../../clients';
import {
    CreateBYOKeysRequest,
    UpdateBYOKeysRequest,
    DeleteBYOKeysRequest,
    CreateBYOKeysResponse,
    UpdateBYOKeysResponse,
    DeleteBYOKeysResponse,
    ListBYOKeysResponse
} from '../bexService.types';

/**
 * Service class for managing user api keys.
 */
class ApiKeyService {

    /**
     * Add new api key for the user.
     * @returns {Promise<CreateBYOKeysResponse>} The response from the server returns created api key.
     */
    async createNewApiKey(data: CreateBYOKeysRequest): Promise<CreateBYOKeysResponse> {
        const response = await bexHttpClient.post('/redis/byo-keys/add-byo-keys', data);
        return response;
    }

    /**
     * Update user api keys.
     * @returns {Promise<UpdateBYOKeysResponse>} The response from the server returns updated api key.
     */
    async updateApiKeys(data: UpdateBYOKeysRequest): Promise<UpdateBYOKeysResponse> {
        const response = await bexHttpClient.put('/redis/byo-keys/update-byo-keys', data);
        return response;
    }

    /**
     * Get user api keys.
     * @returns {Promise<ListBYOKeysResponse>} The response from the server returns list of users api keys.
     */
    async listApiKeys(levelType: 'user' | 'organization', userId: string): Promise<ListBYOKeysResponse> {
        const response = await bexHttpClient.get(`/redis/byo-keys/list-byo-keys/${levelType}/${userId}`);
        return response;
    }

    /**
     * Delete user api keys.
     * @returns {Promise<DeleteBYOKeysResponse>} The response from the server returns status of deleted api keys.
     */
    async deleteApiKeys(data: DeleteBYOKeysRequest): Promise<DeleteBYOKeysResponse> {
        const response = await bexHttpClient.delete('/redis/byo-keys/delete-byo-keys', {
            data
        });
        return response;
    }

}

const apiKeyService = new ApiKeyService();
export { apiKeyService };